import React, { useState, useEffect } from "react";
import UserCard from "../users/UserCard";
import UserAvatar from "../users/UserAvatar";
import Card from 'react-bootstrap/Card';
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import { useForm } from "react-hook-form";
import { EMAIL_PATTERN, JSON_HEADERS } from "../../constants/constants";
import {createElementFromHTML, validateEmail} from "../../utils/utilsHelpers";

export default function MessageBox(props) {
    const [compact, setCompact] = useState(true);
    const { register, handleSubmit, clearErrors, setError, setValue, formState: { errors, isValid, isSubmitting }} = useForm({ mode: 'onBlur'});

    const [isEmailValid, setIsEmailValid] = useState(false);
    const [emailError, setEmailError] = useState(null);
    const [submitCta, setSubmitCta] = useState('Send');
    const [showRemainingForm, setShowRemainingForm] = useState(false);

    const [messageBoxStyles, setMessageBoxStyles] = useState({ top: 'unset', width: '540px', transition: 'none', height: '95vh'});
    const currentExpert = props.selectedExpert;

    const onClose = () => {
        if(compact) {
            dataLayer.push({'event': 'PeerTalk_sneak_close' });
            props.toggleMessageBox()
        } else {
            setCompact(true);
            dataLayer.push({'event': 'PeerTalk_close' });
        }
    }

    useEffect(() => {
        if(!compact) {
            dataLayer.push({'event': 'PeerTalk_fullview' });
        } else setShowRemainingForm(false);
    }, [compact]);

    const onMessageSubmit = async(data) => {
        setSubmitCta('Sending...');
        await fetch(`/users/${currentExpert.id}/send_peer_talk_message`, {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify(data)
        }).then(_ => {
            setMessageBoxStyles({ top: 'unset', transition: 'none'});
            props.onMessageSent()
        });
        dataLayer.push({'event': 'PeerTalk_form_success' });
        setSubmitCta('Continue');
    }

    const renderPrompt = () => {
        return ( 
            <Card className={`shadow-none rounded-3 ${compact ? 'border border-success border-2 p-0' : 'p-2 branded-flag flag-quote border-0'} text-secondary mb-0`} style={ !compact ? {'--flag-color': 'white', '--flag-size': '20px'} : {}}>
                <div className={ compact ? 'bg-success bg-opacity-10 p-2' : ''}>
                    Hey, I use {props.productName} here at {currentExpert.company || 'my company'}. Want to hear about my experience?
                </div>
            </Card>
        )
    }

    const renderMessageField = () => {
        return (
            <Form.Group className="mt-4 mb-3">
                <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder={`Reply to ${currentExpert.username}`}
                    onInput={(e) => e.target.value.length > 1 && setShowRemainingForm(true)}
                    {...register('message', {
                        required: 'This field is required'
                    })}
                />
            </Form.Group>
        )
    }

    const renderEmailField = () => {
        if(showRemainingForm) {
            return (
                <Form.Group className="mb-3 text-start">
                    <Form.Control
                        type="email"
                        id="email"
                        placeholder="Company email"
                        onKeyUp={(e) => validateEmail(e.target.value, 'from_email', isEmailValid, setIsEmailValid, setEmailError, setError, clearErrors)}
                        {...register("from_email", {
                            required: 'This field is required',
                            pattern: {
                                value: EMAIL_PATTERN,
                                message: "Please enter a valid email address"
                            },
                            validate: () => isEmailValid || emailError
                        })} />
                    {errors.from_email && <Form.Text className="text-danger">{errors.from_email.message}</Form.Text>}
                </Form.Group>
            )
        }
    }

    const renderGdpr = () => {
        if(showRemainingForm) {
            let consent = `In order to make this request from a PeerSpot community member, ${props.gdpr}`;
            return (
                <Form.Check type='checkbox' id='gdpr_checkbox' className={'form-check-primary secondary-links'}>
                    <Form.Check.Input type='checkbox'
                                      isValid {...register("gdpr_checkbox", {required: 'This field is required'})} />
                    <Form.Check.Label
                        className={'content-styling text-dark font-12 text-start'}>{createElementFromHTML(consent)}
                        {errors.gdpr_checkbox &&
                            <Form.Text className="text-danger fw-normal">{errors.gdpr_checkbox.message}</Form.Text>}
                    </Form.Check.Label>
                </Form.Check>
            )
        }
    }

    const renderVerifiedUser = () => {
        return (
            <div className={'d-flex justify-content-center align-items-center py-2'}>
                <i className={'far fa-badge-check text-success pe-1'}></i>
                <span className={'text-secondary'}>Verified user of {props.productName}</span>
            </div>
        )
    }


    const renderMessageBox = () => {
        if(compact) {
            // return (
            //     <div className={'px-2 bg-success bg-opacity-10 border border-success border-2 h-100 rounded-3 pb-3'} onClick={() => setCompact(false)} style={{ cursor: 'pointer' }}>
            //         <div className={'border-bottom'}>
            //             <UserCard
            //                 user={currentExpert}
            //                 renderAsLink={false}
            //                 showAvatarDot={true}
            //                 nameClasses={'text-medium font-14 fw-light'}
            //                 userDetailsClasses={'text-secondary fw-bolder font-15'}
            //             />
            //         </div>
            //         {renderVerifiedUser()}
            //         {renderPrompt()}
            //         <Button variant={'secondary'} className={'btn-block mt-3'}>Yes, tell me more!</Button>
            //     </div>
            // )
            return (
                <div className={'d-flex align-items-center gap-3 mb-3'} onClick={() => setCompact(false)} style={{ cursor: 'pointer' }}>
                     {renderPrompt()}
                    <div className={'w-auto position-relative'}>
                        <UserAvatar user={currentExpert} avatarSize={60} />
                        <div className={`position-absolute top-0 start-5 bg-pro rounded-pill`} style={{ width: '13px', height: '13px' }} />
                    </div>
                </div>
            )
        } else {
            return (
                <div className={'h-100 rounded-3 border'}>
                    <div className={'p-2 text-secondary fs-6'}>Send message</div>
                    <div className={'px-2 bg-light h-100 pb-3 rounded-3 rounded-top-0'}>
                        <div className={'border-bottom'}>
                            <UserCard
                                user={currentExpert}
                                showAvatarDot={true}
                                nameClasses={'text-medium font-14 fw-light'}
                                userDetailsClasses={'text-secondary fw-bolder font-15'}
                                renderAsLink={false} />
                        </div>
                        {renderVerifiedUser()}
                        {/* <Button variant={'outline-secondary'} className={'mb-3 btn-block'} size={'sm'} onClick={() => props.onToggleExperts(true)}>
                            <i className={'fas fa-user-group pe-1'}></i>
                            Find another community member
                        </Button> */}
                        {renderPrompt()}
                        <Form
                            noValidate={true}
                            acceptCharset='UTF-8'
                            onSubmit={handleSubmit(onMessageSubmit)}
                        >
                            {renderMessageField()}
                            {!showRemainingForm && <div style={{height: '152px'}}/>}
                            {renderEmailField()}
                            {renderGdpr()}
                            <input type='hidden' id='product_id' key='product_id'
                                   value={props.productId} {...register('product_id')} />
                            <input type='hidden' id='category_id' key='category_id'
                                   value={props.categoryId} {...register('category_id')} />
                            <input type='hidden' id='create_lead' key='create_lead'
                                   value={true} {...register('create_lead')} />
                            <input type='hidden' id='authenticity_token' key='authenticity_token'
                                   value={props.token} {...register('authenticity_token')} />
                            <Button variant="primary" type="submit" className={'btn-block btn-hover-cursor mt-4'}
                                    disabled={isSubmitting}>
                                {submitCta}
                            </Button>
                        </Form>
                    </div>
                </div>
            )
        }
    }

    return (
        <div className={`slidebar slidebar-right-sm slidebar-sm ${compact ? 'shadow-none bg-transparent' : 'shadow-lg rounded-3 mb-2'} ${props.show && 'slidebar-enabled me-3'}`} style={ compact ? {top: 'unset', width: '400px'} : messageBoxStyles}>
            {!compact && <div className={'position-absolute'} style={{right: '0', zIndex: 10, cursor: 'pointer'}}>
                <i onClick={onClose} className="fal fa-times fs-5 m-2"></i>
            </div>}
            {renderMessageBox()}
        </div>
    )
}